import classNames from "classnames";
import { Card } from "./Card/Card";

export const Feed = ({
  items,
}: {
  items: Array<Travelguide.OOI>;
}): React.ReactElement => {
  return (
    <div
      className={classNames(
        "grid grid-cols-1 md:grid-cols-[repeat(3,minmax(0,1fr))] gap-4"
      )}
    >
      {items.map((item, i) => (
        <Card key={i} item={item} />
      ))}
    </div>
  );
};
